<template>
  <div class="page-template">
    <div class="page-title">{{ title }}
    </div>
    <div class="page-edit">
      <form-template ref="formTemplate" @submit="submitData">
      </form-template>
    </div>
  </div>
</template>

<script>
  import formTemplate from "@/components/template/formTemplate";
  import api from "@/config/api";

  export default {
    components: {formTemplate},
    data() {
      return {
        title: '',
        addColumns: {
          formType: 'other',
          labelWidth: "280px",
          span: 24,
          columns: [
            {label: '基础设置', type: 'title'},
            {
              label: "",
              type: "id",
            },
            {
              label: "供应商结算先对账后结算模式",
              type: "radio",
              prop: "supplierBeforeBill",
              data: [{label: '启用', id: 1}, {label: '不启用', id: 0},]
            },
            {
              label: "客户结算先对账后结算模式",
              type: "radio",
              prop: "customerBeforeBill",
              data: [{label: '启用', id: 1}, {label: '不启用', id: 0},]
            },
          ],
          formData: {}
        }
      }
    },
    mounted() {
      this.title = document.title;
      this.getData();
    },
    methods: {
      submitData(formModel) {
        this.$axios.fetchPost(api.settle.settlementSetting, formModel).then(data => {
          if (data.code === 200) {
            Object.assign(formModel, data.data);
            this.$notify({
              type: "success",
              title: '提交操作',
              message: '成功',
              showClose: false,
            });
            // this.$message({type: 'success', message: '操作成功'});
          } else {
            this.$message({type: 'error', message: data.errorMsg});
          }
        }).catch((e) => {
          this.$notify({
            type: "error",
            title: '提交操作',
            message: '失败',
            showClose: false,
          });
          // this.$message({type: 'error', message: '修改失败'});
        });
      },
      getData() {
        this.$axios.fetchGet(api.settle.settlementSetting + '/detail').then(data => {
          if (data.code === 200) {
            this.addColumns.formData = data.data;
            this.$refs['formTemplate'] && this.$refs['formTemplate'].initData(this.addColumns);
          } else {
            this.$message({type: 'error', message: data.errorMsg});
          }
        }).catch((e) => {
          this.$message({type: 'error', message: '请求失败'});
        });
      },
    }
  }
</script>




// WEBPACK FOOTER //
// src/page/settle/Setting.vue